// extracted by mini-css-extract-plugin
export default {"container":"_1vIOaFRir6"};
    if(module.hot) {
      // 1623933219156
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  